export default __webpack_public_path__ + "2a83ff0d6139a733630f5361f6f7d15c.png";